import React, { useEffect, useState } from "react";
import Preloading from "../../../components/basics/Preloading";
import back from "../../../assets/images/icons/arrow-right2.svg";
import { Link, useParams } from "react-router-dom";
import methods from "../../../services/utility";
import apiMethod from "../../../services/api-service";
import Paginations from "../../../components/paginaton/Paginations";
import DeleteModal from "../../../components/deleteModal/DeleteModal";
import EditIcon from "../../../assets/images/icons/editIcon.svg";
import DeleteIcon from "../../../assets/images/icons/deleteIcon.svg";
import newLogo from "../../../assets/images/icons/new.png";
import copy from "../../../assets/images/icons/copy.png";

const CreateWareHouse = () => {
  const { restaurantId } = useParams();
  const [loading, setLoading] = useState();
  const [gridData, setGridData] = useState([]);
  const [selectId, setSelectId] = useState(null);
  const [wareHouseType, setWareHouseType] = useState([]);
  const [categoryWareHouse, setCategoryWareHouse] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [filterModel, setFilterModel] = useState({
    branchId: "",
    restaurantId: restaurantId,
    parentId: "",
    title: "",
    code: "",
    size: 10,
    part: 1,
    total: 0,
    parts: 0,
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    code: "",
    description: "",
    warehouseType: 0,
    parentId: null,
    categoryId: 0,
    restaurantId: restaurantId,
  });

  const resetForm = () => {
    formModel.id = 0;
    formModel.code = "";
    formModel.title = "";
    formModel.description = "";
    formModel.restaurantId = restaurantId;
    formModel.parentId = null;
    formModel.categoryId = 0;
    formModel.warehouseType = 0;
    setFormModel({ ...formModel });
  };

  const resetFilters = () => {
    filterModel.restaurantId = restaurantId;
    filterModel.branchId = "";
    filterModel.title = "";
    filterModel.parentId = null;
    filterModel.code = "";
    filterModel.size = 10;
    filterModel.part = 1;
    filterModel.parts = 0;
    filterModel.total = 0;
    setFilterModel({ ...filterModel });
  };

  const getGridData = async (customPart = null) => {
    const part = customPart ? customPart : filterModel.part;
    setLoading(true);
    const resp = await apiMethod.getWarehouses(
      filterModel.branchId,
      filterModel.restaurantId,
      filterModel.title,
      filterModel.code,
      filterModel.size,
      part
    );
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      filterModel.part = part;
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
    setLoading(false);
  };

  const getCategory = async () => {
    const resp = await apiMethod.getAllWarehouseCategories(
      filterModel.branchId,
      filterModel.restaurantId,
      ""
    );
    if (methods.showApiErrors(resp)) {
      setCategoryWareHouse(resp.data);
    }
  };

  const getWarHouseType = async () => {
    const resp = await apiMethod.getWarehouseTypes();
    if (methods.showApiErrors(resp)) {
      setWareHouseType(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getGridData();
      await getWarHouseType();
      await getCategory();
      setLoading(false);
    };
    bindData();
  }, []);

  const callPager = async (i) => {
    setLoading(true);
    setFilterModel({ ...filterModel, part: i });
    await getGridData(i);
    setLoading(false);
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    const newFilter = resetFilters();
    await getGridData(newFilter);
    setLoading(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    resetForm();
  };

  const closeCreateModal = () => {
    resetForm();
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getWarehouseInfo(id);
    if (methods.showApiErrors(resp)) {
      setFormModel({
        ...formModel,
        id: resp.data.id,
        title: resp.data.title,
        description: resp.data.description,
        code: resp.data.code,
        categoryId: resp.data.categoryId,
        warehouseType: resp.data.warehouseType,
      });
    }
    setLoading(false);
  };

  const selectَItemToDelete = (item) => {
    setSelectId(item);
    setShowDeleteModal(true);
  };

  const addWarhouse = async () => {
    setLoading(true);
    const resp = await apiMethod.createWarehouse(formModel);
    if (methods.showApiErrors(resp)) {
      resetForm();
      await getGridData();
    }
    setLoading(false);
  };

  const deleteItem = async () => {
    setLoading(true);
    try {
      const resp = await apiMethod.removeWarehouse(selectId.id);
      if (!methods.showApiErrors(resp)) return false;

      await getGridData();
      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const copyItem = (item) => {
    console.log(item);
    formModel.title = item.title;
    formModel.description = item.description;
    formModel.warehouseType = item.warehouseType;
    formModel.categoryId = item.categoryId;
    setFormModel({ ...formModel });
    const el = document.getElementById("add_item");
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className="d-none d-lg-block mb-3">
              <Link
                to={`/warehouse/${restaurantId}`}
                className="text-start mb-3 link back-link"
              >
                <span>
                  <img src={back} className="" alt="return" />
                </span>
                بازگشت
              </Link>
            </div>
            <div className="d-lg-none d-flex justify-content-between align-items-baseline saleheader">
              <div>
                <Link
                  to={`/${restaurantId}/dashboard`}
                  className="link back-link"
                >
                  <span>
                    <img src={back} className="" alt="return" />
                  </span>
                </Link>
                مدیریت انبار
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className="saleheader d-none d-lg-block">
              <p>
                مدیریت انبار
                <a
                  href={`/wareHouse/${restaurantId}`}
                  className="link rtlicon me-1"
                  title="برای اطلاعات بیشتر کلیک کنید"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain mb-3" id="add_item">
              <div className="d-flex align-items-center gap-4 justify-content-end">
                <button className="btn-action" onClick={resetForm}>
                  <img src={newLogo} alt="Image" />
                  <span style={{ fontSize: "12px" }}>جدید</span>
                </button>
              </div>
              <div className="mb-4">
                <span className="fw-bold fs-5">افزودن / ویرایش انبار جدید</span>
              </div>
              <div className="row g-2">
                <div className="col-md-4 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    نوع انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.warehouseType}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        warehouseType: e.target.value,
                      });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {wareHouseType.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-4 mb-3">
                  <label htmlFor="categoryWarHouse" className="form-label">
                    دسته بندی انبار
                  </label>
                  <select
                    id="categoryWarHouse"
                    className="form-select input-select"
                    aria-label="Default select example"
                    value={formModel.categoryId}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        categoryId: e.target.value,
                      });
                    }}
                  >
                    <option value="">انتخاب کنید</option>
                    {categoryWareHouse.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.parentTitle + " / " + item.title}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-4 mb-4">
                  <label htmlFor="title" className="form-label">
                    عنوان
                  </label>
                  <input
                    className="form-control input-form"
                    type="text"
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.title}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        title: e.target.value,
                      });
                    }}
                    placeholder="عنوان را وارد بنویسید"
                  />
                </div>
                <div className="col-12">
                  <label htmlFor="title" className="form-label">
                    توضیحات
                  </label>
                  <textarea
                    className="form-control input-textarea"
                    type="text"
                    rows={4}
                    aria-label="Add your item here..."
                    style={{ direction: "rtl", textAlign: "right" }}
                    value={formModel.description}
                    onChange={(e) => {
                      setFormModel({
                        ...formModel,
                        description: e.target.value,
                      });
                    }}
                    placeholder="توضیحات را وارد بنویسید"
                  ></textarea>
                </div>
                <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                  <button
                    type="button"
                    className="btn custome-btn btn-link-purple"
                    onClick={closeCreateModal}
                  >
                    انصراف
                  </button>
                  <button
                    type="button"
                    className="btn custome-btn btn-purple"
                    onClick={addWarhouse}
                  >
                    ثبت و ذخیره
                  </button>
                </div>
              </div>
            </div>
            <div className="salemain mb-3">
              <div className="row g-3">
                <div className="col-12 col-md-3">
                  <label htmlFor="title" className="mb-2">
                    عنوان
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="title"
                    value={filterModel.title}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        title: e.target.value,
                        part: 1,
                      })
                    }
                    placeholder="عنوان را وارد نمایید"
                  />
                </div>
                <div className="col-12 col-md-3">
                  <label htmlFor="code" className="mb-2">
                    کد
                  </label>
                  <input
                    type="text"
                    className="form-control input-form"
                    id="code"
                    value={filterModel.code}
                    onChange={(e) =>
                      setFilterModel({
                        ...filterModel,
                        code: e.target.value,
                        part: 1,
                      })
                    }
                    placeholder="کد را وارد نمایید"
                  />
                </div>
                <div className="col-2 d-flex align-items-end">
                  <div className="d-flex align-items-center gap-2">
                    <button
                      className="btn-wrap search-btn"
                      onClick={searchItem}
                    >
                      <i className="bi bi-search"></i>
                    </button>
                    <button
                      className="btn-wrap reset-btn"
                      onClick={clearSearch}
                    >
                      <i className="bi bi-arrow-clockwise"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="salemain">
              <span className="d-block text-start fw-bold fs-5"> انبار</span>
              <div className="table-responsive warhousetable">
                <table className="table table-md table-custom">
                  <thead className="align-middle">
                    <tr>
                      <th scope="col vertical-center" width="20px">
                        ردیف
                      </th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center">گروه</th>
                      <th scope="col vertical-center">کد</th>
                      <th scope="col vertical-center">نوع انبار</th>
                      <th scope="col vertical-center">کالای انبار</th>
                      <th scope="col vertical-center" width="100px">
                        عملیات
                      </th>
                    </tr>
                  </thead>
                  <tbody className="align-middle">
                    {gridData.map((item, index) => (
                      <tr key={item.id}>
                        <th scope="row">
                          {(filterModel.part - 1) * filterModel.size +
                            index +
                            1}
                        </th>
                        <td>{item.title}</td>
                        <td>{item.categoryTitle}</td>
                        <td>{item.code}</td>
                        <td>
                          {{
                            1: "پایه",
                            2: "تولید",
                            3: "فروشگاه",
                          }[item.warehouseType] || "نامشخص"}
                        </td>
                        <td>
                          <Link
                            to={`/warehouse/${restaurantId}/productWarehouse/${item.id}`}
                          >
                            <button className="btn btn-purple btn-sm">
                              کالای انبار
                            </button>
                          </Link>
                        </td>
                        <td className="d-flex align-items-center justify-content-center gap-2">
                          <button
                            className="button-action copy-btn"
                            onClick={() => copyItem(item)}
                          >
                            <img src={copy} alt="Copy" />
                          </button>
                          <button
                            onClick={() => editItem(item.id)}
                            className="button-action"
                            type="button"
                          >
                            <img src={EditIcon} alt="Edit" />
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(item)}
                            className="button-action"
                            type="button"
                          >
                            <img src={DeleteIcon} alt="delete" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 && (
                  <div className="pagination justify-content-center mt-5">
                    <Paginations
                      total={filterModel.total}
                      size={filterModel.size}
                      onPageChange={callPager}
                    />
                  </div>
                )}
              </div>
            </div>
          </>
        }
      </>
    );
  };

  return (
    <div>
      <>
        {renderItems()}
        {showDeleteModal && (
          <DeleteModal
            showModal={showDeleteModal}
            closeModal={closeDeleteModal}
            deleteItem={deleteItem}
            text={"انبار"}
          />
        )}
      </>
    </div>
  );
};

export default CreateWareHouse;
